<template>
  <div class="d-book-review-actions space-top-2em">
    <div
      v-show="vm.isMarkedAsSpam"
      class="panel background-translucent"
    >
      You've marked this book as spam.
    </div>

    <div
      v-show="(isSkipped && !vm.isMarkedAsSpam)"
      class="panel panel-thin background-translucent"
    >
      <div class="grid-flex grid-middle grid-no-response">
        <div class="grid-item padding-left-1em padding-right-1em">
          You've skipped this book – 
          <a :href="vm.reviewersDashboardUrl">
            return to dashboard
          </a>
        </div>
        <div class="grid-item-shrink">
          <button
            class="button-translucent"
            :disabled="vm.isProcessing"
            type="button"
            @click="undoSkipBook()"
          >
            Undo
          </button>
        </div>
      </div>
    </div>

    <div
      v-show="(!isSkipped && !vm.isMarkedAsSpam)"
      class="grid-flex grid-middle grid-no-response"
    >
      <div class="grid-item-shrink">
        <button
          class="button-yellow button-lg"
          :disabled="vm.isProcessing"
          type="button"
          @click="reviewBook()"
        >
          <span class="visible-until-sm">Review book</span>
          <span class="hidden-until-md">Review this book</span>
        </button>
      </div>

      <div class="grid-item visible-until-sm" />

      <div class="grid-item-shrink">
        <button
          class="button-translucent button-lg space-left-2em space-right-2em"
          :disabled="vm.isProcessing"
          type="button"
          @click="skipBook()"
        >
          Skip
        </button>
      </div>

      <div class="grid-item hidden-until-md" />

      <div class="grid-item-shrink">
        <button
          class="button-translucent button-lg"
          :disabled="vm.isProcessing"
          type="button"
          @click="markAsSpam()"
        >
          <span class="visible-until-sm">Spam</span>
          <span class="hidden-until-md">Mark as spam</span>
        </button>
      </div>
    </div>

    <DBookMarkAsSpam
      v-if="(!!vm.isReportingBook && !isSkipped && !vm.isMarkedAsSpam)"
      :book="vm.isReportingBook"
      @dismiss-report-spam="dismissReportSpam"
      @book-reported-as-spam="bookReportedAsSpam"
    />

    <DBookReviewBook
      v-if="(!!vm.isConfirmingReviewBook && !isSkipped && !vm.isMarkedAsSpam)"
      :book="vm.isConfirmingReviewBook"
      @dismiss-review-book="dismissReviewBook"
    />
  </div>
</template>

<script>
import Vue from 'vue';

import DBookMarkAsSpam from '@d-components/modals/d-book-mark-as-spam/d-book-mark-as-spam.vue';
import DBookReviewBook from '@d-components/modals/d-book-review-book/d-book-review-book.vue';
import { getErrorMessage } from '@d-shared/utils/errors';
import libraryService from '@d-services/library-service/library-service';
import URLS from '@d-shared/urls/urls';

export default {
  components: {
    DBookMarkAsSpam,
    DBookReviewBook,
  },
  props: {
    isBookSkipped: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    vm: {
      book: null,
      isConfirmingReviewBook: null,
      isMarkedAsSpam: false,
      isProcessing: false,
      isReportingBook: null,
      reviewersDashboardUrl: URLS.app.library.dashboard,
    },
  }),
  computed: {
    isSkipped() {
      return this.vm.book && this.vm.book.isSkipped;
    },
  },
  mounted() {
    this.loadBookInfo();
  },
  methods: {
    bookReportedAsSpam() {
      this.$set(this.vm, 'isMarkedAsSpam', true);
    },

    dismissReportSpam() {
      this.$set(this.vm, 'isReportingBook', null);
    },

    dismissReviewBook() {
      this.$set(this.vm, 'isConfirmingReviewBook', null);
    },

    async loadBookInfo() {
      const bookInfoEl = document.getElementById('book-review-info');
      if (!bookInfoEl) {
        return;
      }

      this.$set(this.vm, 'isProcessing', true);

      try {
        const bookInfo = JSON.parse(bookInfoEl.dataset.book);
        bookInfoEl.remove();

        this.$set(this.vm, 'book', bookInfo);
        this.setBookSkippedStatus(this.isBookSkipped);
      } catch (error) {
        Vue.duiNotificationManager.error(getErrorMessage(error));
      }

      this.$set(this.vm, 'isProcessing', false);
    },

    markAsSpam() {
      this.$set(this.vm, 'isReportingBook', this.vm.book);
    },

    reviewBook() {
      this.$set(this.vm, 'isConfirmingReviewBook', this.vm.book);
    },

    setBookSkippedStatus(status) {
      this.$set(this.vm.book, 'isSkipped', status);
    },

    async skipBook() {
      this.$set(this.vm, 'isProcessing', true);

      try {
        await libraryService.skipBook(this.vm.book.slug);
        this.setBookSkippedStatus(true);
      } catch (error) {
        Vue.duiNotificationManager.error(getErrorMessage(error));
      }

      this.$set(this.vm, 'isProcessing', false);
    },

    async undoSkipBook() {
      this.$set(this.vm, 'isProcessing', true);

      try {
        await libraryService.cancelSkipBook(this.vm.book.slug);
        this.setBookSkippedStatus(false);
      } catch (error) {
        Vue.duiNotificationManager.error(getErrorMessage(error));
      }

      this.$set(this.vm, 'isProcessing', false);
    },
  },
};
</script>
